import React from 'react';
import GuideLines from './guidelines';
import { linearTransform2D, selection2DToRange2D } from '../../utilities';
/**
 * Provides a transparent selection rectangle which allows users to select a rectangular region of an SVG. Mouse events
 * are enabled while the user is holding down the control or shift key. Releasing the mouse triggers a callback with
 * information about the selected region; releasing the key during selection cancels the selection.
 */
class SelectionRect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selecting: false,
            selection: [],
            transform: SelectionRect.transform(props)
        };
        this._onKeyDown = this.onKeyDown.bind(this);
        this._onKeyUp = this.onKeyUp.bind(this);
    }
    mouseLocation(e) {
        const r = e.target.getBoundingClientRect();
        return {
            x: (e.clientX - r.left) * this.props.dimensions.width / r.width,
            y: (e.clientY - r.top) * this.props.dimensions.height / r.height
        };
    }
    static transform(props) {
        return linearTransform2D({
            x: { start: 0, end: props.dimensions.width },
            y: { start: props.dimensions.height, end: 0 }
        }, props.domain);
    }
    static getDerivedStateFromProps(props, state) {
        return Object.assign(Object.assign({}, state), { transform: SelectionRect.transform(props) });
    }
    componentDidMount() {
        document.addEventListener('keydown', this._onKeyDown);
        document.addEventListener('keyup', this._onKeyUp);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this._onKeyDown, false);
        document.removeEventListener('keyup', this._onKeyUp, false);
    }
    onKeyDown(e) {
        if (e.key === 'Control' || e.key === 'Shift')
            this.setState({
                selecting: true
            });
    }
    onKeyUp(e) {
        if (e.key === 'Control' || e.key === 'Shift')
            this.setState({
                selecting: false,
                selectionStart: null,
                selection: []
            });
    }
    onMouseDown(e) {
        if (!this.state.selecting) {
            return;
        }
        if (this.props.freeform)
            this.setState({
                selection: [this.mouseLocation(e)]
            });
        else
            this.setState({
                selectionStart: this.mouseLocation(e)
            });
    }
    onMouseMove(e) {
        this.props.onMouseMove && this.props.onMouseMove(e, this.mouseLocation(e), this.state.transform(this.mouseLocation(e)));
        if (this.props.freeform && this.state.selection.length > 0)
            this.setState({
                selection: [...this.state.selection, this.mouseLocation(e)]
            });
        else
            this.setState({
                mouseLocation: this.mouseLocation(e)
            });
    }
    onMouseOut() {
        this.setState({
            selection: [],
            mouseLocation: null
        });
    }
    onMouseUp(e) {
        if (this.props.freeform && this.state.selection)
            this.props.onFreeformSelectionEnd && this.props.onFreeformSelectionEnd(this.state.selection.map(this.state.transform).concat(this.state.transform(this.mouseLocation(e))));
        else if (this.state.selectionStart)
            this.props.onSelectionEnd && this.props.onSelectionEnd(selection2DToRange2D({
                start: this.state.transform(this.state.selectionStart),
                end: this.state.transform(this.mouseLocation(e))
            }));
        this.setState({
            selecting: false,
            selection: [],
            selectionStart: null
        });
    }
    selectionPath() {
        if (!this.state.selection || this.state.selection.length === 0)
            return "";
        return `M ${this.state.selection[0].x} ${this.state.selection[0].y} ` + this.state.selection.slice(1).map((point) => (`L ${point.x} ${point.y} `)).join(" ");
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.state.selecting && (this.props.freeform ? (this.state.selection && (React.createElement("path", Object.assign({ d: this.selectionPath(), strokeWidth: 2, stroke: "#000000", fill: "none" }, this.props.freeformProps)))) : (this.state.selectionStart && this.state.mouseLocation && (React.createElement(React.Fragment, null,
                React.createElement("rect", { fill: this.props.color || "#6666aa", fillOpacity: 0.336, x: Math.min(this.state.selectionStart.x, this.state.mouseLocation.x), y: Math.min(this.state.selectionStart.y, this.state.mouseLocation.y), width: Math.abs(this.state.selectionStart.x - this.state.mouseLocation.x), height: Math.abs(this.state.selectionStart.y - this.state.mouseLocation.y) }),
                this.props.withGuideLines && (React.createElement(GuideLines, Object.assign({ dimensions: this.props.dimensions, position: this.state.selectionStart }, (this.props.guideLineProps || {})))))))),
            this.props.withGuideLines && this.state.mouseLocation && (React.createElement(GuideLines, Object.assign({ dimensions: this.props.dimensions, position: this.state.mouseLocation }, (this.props.guideLineProps || {})))),
            React.createElement("rect", { fill: "#000000", fillOpacity: 0, width: this.state.selecting || this.props.withGuideLines ? this.props.dimensions.width : 0, height: this.state.selecting || this.props.withGuideLines ? this.props.dimensions.height : 0, x: 0, y: 0, onMouseDown: this.onMouseDown.bind(this), onMouseMove: this.state.selecting || this.props.withGuideLines ? this.onMouseMove.bind(this) : undefined, onMouseUp: this.onMouseUp.bind(this) })));
    }
}
export default SelectionRect;
